import { securedUrls } from './urls/secured-urls';
import { publicUrls } from './urls/public-urls';

export const environment: any = {
  name: 'dev',
  production: false,
  containerId: 'GTM-TL7LXNC',
  propertyID: 'UA-75986060-8',
  applicationRoot: '/selfservice',
  mock: false,
  empbaseUrl: '',
  serviceSecuredURLs: securedUrls,
  servicePublicURLs: publicUrls,
  OKTA_baseURL: 'https://logintest.carefirst.com',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts